import {Drawer} from 'antd';
import styled from 'styled-components';

const StyledAddNewCardFormModal = styled(Drawer)`
  .ant-drawer-header-title {
    flex-direction: row-reverse;
    button {
      margin-inline-end: 0;
      margin-inline-start: 12px;
    }
  }
  .ant-drawer-title {
    font-weight: 500;
  }
  .ant-drawer-footer {
    display: flex;
    justify-content: end;
    padding: 16px 24px;
  }

  .d-none-label {
    .ant-form-item-label {
      display: none;
    }
  }
  
  .ant-divider {
    margin-top: 12px;
  }
  
  .card-banner {
    margin-top: 8px;
  }
`;


export {
  StyledAddNewCardFormModal,
}
